var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.appointmentUseCase)?_c('ContactInformationForm',{attrs:{"formModel":_vm.formModel}}):_c('ContactInformation',{attrs:{"formModel":_vm.formModel}})
}
var staticRenderFns = []

export { render, staticRenderFns }